export class AlterarParcelaDTO {
    dataParcela: Date;
    valorParcela: number;
    contratoId: number;
    usuario: string;
}